import { pathgen } from 'object-path-generator';
export const AttachFilesTestIds = pathgen('AttachFilesTestIds');